<template>
<nav class="navbar container" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <a class="navbar-item" href="/">
      <strong class="is-size-4">Hoogheem</strong>
    </a>
    <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarOptions" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>
  
  <div id="navbarOptions" class="navbar-menu" :class="{ 'is-active': showNav }">
    <div class="navbar-start">
      <router-link to="/" class="navbar-item">Home</router-link>
      <router-link to="/about" class="navbar-item">About</router-link>
    </div>
  </div>
  
  <div class="navbar-end">
    <div class="navbar-item">
      <div class="buttons">
        <a class="button is-dark" @click="github">
          <strong>GitHub</strong>
        </a>
        <a class="button is-dark" @click="ext_linkedin">
          <strong>LinkedIn</strong>
        </a>
      </div>
    </div>
  </div>
  
</nav>

</template>

<script>
export default {
    name: 'Nav',
    data () {
      return {
        showNav: false
      }
    },
    methods: {
      github: function() {
        this.$router.push('/ext_github')
      },
      ext_linkedin: function() {
        this.$router.push('/ext_linkedin')
      }
    }
}
</script>

<style lang="scss" scoped>
  nav {
    margin-top: 25px;
    margin-bottom: 30px;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: #d88d00;
      }
    }
  }
</style>
